import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import "./Users2.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import accimg from "../images/accimg.png";
import CancelIcon from "@mui/icons-material/Cancel";
import EditRole from "../EditRole/EditRole";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import { dateTimeFormat } from "../utils/common";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Modal from "react-modal";

// const RECORDS_PER_PAGE = 10;
// let scrollDebounce = false;

const Users = ({ fetchedRole }) => {
  const [userInfo, setUserInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [stopPagination, setStopPagination] = useState(false);
  const [loadNew, setLoadNew] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [openDeleteMsg, setOpenDeleteMsg] = useState(false);
  const [openAddMsg, setOpenAddMsg] = useState(false);
  
  // const [loadNext, setLoadNext] = useState([]);
  // const [numId, setNumId] = useState();
  const [saveEditRole, setSaveEditRole] = useState(false);

  const [role, setRole] = useState([]);
  const [isEditRole, setIsEditRole] = useState(0);
  const [searchTerm2, setSearchTerm2] = useState("");
  
  const limit = 10;
  let page = 1;
  let scrollDebounce = false;
  const loadNext = () => {
    if (!stopPagination) {
      axiosApiInstance.get(`/user/${page}/${limit}`).then((res) => {
        if (res.status === 200) {
          let totalCount =  res.data.totalCount;
          let fetchLenth = res.data.data.length;
          const totalFetchedUsers = userInfo.length + res.data.data.length;

          setLoading(false);
          if (fetchLenth < limit || totalFetchedUsers >= totalCount) {
            setStopPagination((prevValue) => {
              return true;
            });
          }

          setUserInfo((prevState) => [ ...prevState,...res.data.data]);
          page += 1;
        }
      });
    }
  };

  
  useEffect(() => {
    setUserInfo([]);
    setStopPagination(false);
  }, [saveEditRole,isOpen])


  const scrollHandle = (e) => {
    if (
      window.innerHeight + e.target.documentElement.scrollTop + 1 >=
        e.target.documentElement.scrollHeight &&
      !stopPagination &&
      !scrollDebounce
    ) {
      scrollDebounce = true;
      loadNext();
      setLoadNew(true);
      setTimeout(function () {
        scrollDebounce = false;
      }, 2000);
    }
   
  };

  setTimeout(() => {
    setLoadNew(false);
  }, 1000);

  useEffect(() => {
    loadNext();
    window.addEventListener("scroll", scrollHandle);
    return () => {
      window.removeEventListener("scroll", scrollHandle);
    };
  }, [stopPagination]);

  // useEffect(()=>{
  //   loadNext();
  // },[openDeleteMsg])

  const handleEdit = (id) => {
    setIsEditRole(id);
  };

  useEffect(() => {
    axiosApiInstance
      .get("/role")
      .then((req) => setRole(req.data.data))
      .catch((err) => console.log(err));
  }, []);



  const fetchedToken = localStorage.getItem("token");

  let roleid;

  const [userId, setUserId] = useState([]);
  const [userRole, setUserRole] = useState([]);


  const handleclick = (r, empid) => {
    setUserRole(r);
    setUserId(empid);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const closeDeleteModal = () => {
    setOpenDeleteMsg(false);
  };

  const closeAddModal = () => {
    setOpenAddMsg(false);
  };

  const deleterole = () => {
    let id;
    {
      role?.map((ro) => {
        if (ro.name === userRole) {
          roleid = ro.id;
        }
      });
    }

    let data = {
      roleId: roleid,
      employeeId: userId,
    };

    axiosApiInstance
      .delete("/role", { data: data })
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setUserInfo(userInfo.filter((x) => x.r !== userRole));
          setOpenDeleteMsg(true);
          setIsOpen(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
      

  };

  const searchFilter = (e) => {
    setSearchTerm(e.target.value);
  };

  const navigate = useNavigate();

  const searchHandler = (searchTerm) => {
    setSearchTerm2(searchTerm);
  };

  return (
    <>
      <AllTicketsHeader
        searchKeyword={searchHandler}
        term={searchTerm2}
      />
      <SideBar />
      <div className="users-all">
        <div className="background-users">
          <div className="users-head">
            <h3>All Employees</h3>
            <input
              placeholder="Search the Employee"
              onChange={searchFilter}
            ></input>
          </div>
          {userInfo.length < 1 ? (
            <CircularProgress />
          ) : (
            userInfo
              .filter((us) => {
                if (searchTerm == "") {
                  return us;
                } else if (
                  us.name.toLowerCase().includes(searchTerm.toLowerCase())
                ) {
                  return us;
                }
              })
              .map((us, id) => (
                <div className="users-card" key={id}>
                  <Typography className="suggestion">
                    <div className="acc-content">
                      <div className="user-intro">
                        <img
                          className="ac-icon"
                          src={us.profilePath ? us.profilePath : accimg}
                        ></img>
                        <div className="user-text">
                          <span>{us.name}</span>
                          <p>{us.email}</p>
                          <p>{us.phoneNumber}</p>
                          {fetchedRole[0] === "Super Admin" ||
                          fetchedRole[1] === "Super Admin" ||
                          fetchedRole[2] === "Super Admin" ? (
                            <>
                              <div className="change-role">
                                <h6>Role</h6>
                                <span
                                  key={id}
                                  onClick={() => handleEdit(us.id)}
                                >
                                  Edit
                                </span>
                              </div>
                              {isEditRole === us.id ? (
                                <EditRole 
                                setIsAddRole={(value = false) => {
                                    if (value === true) {
                                        loadNext();
                                        setSaveEditRole(!saveEditRole)
                                        setOpenAddMsg(true)
                                    }
                                  }}
                                  onRoleChange={handleEdit}

                                  id={us.id}
                                />
                              ) : (
                                <>
                                  {us?.roles?.map((rol, id) => (
                                    <div className="delete-role">
                                      {rol === "Super Admin" ? (
                                        <p key={id}>{rol}</p>
                                      ) : (
                                        <>
                                          <p key={id}>{rol}</p>
                                          <DeleteOutlineOutlinedIcon
                                            className="deleterole-icon"
                                            type="button"
                                            onClick={() =>
                                              handleclick(rol, us.id)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  ))}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="user-role">
                                {us?.roles?.map((rol, id) => (
                                  <span key={id}>{rol}</span>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="user-cat">
                        {us?.categoryName?.map((cat, id) => (
                          <span key={id}>{cat}</span>
                        ))}
                      </div>
                      <div className="user-tick-count">
                        <div className="total-tick-user">
                          <p>
                            Total Tickets<span>{us.totalTickets}</span>
                          </p>
                        </div>
                        <div className="indi-count">
                          <div className="indi-tick-user-new">
                            <p>
                              New<span>{us.opened}</span>
                            </p>
                          </div>
                          <div className="indi-tick-user-in">
                            <p>
                              Inprogress<span>{us.inProgress}</span>
                            </p>
                          </div>
                          <div className="indi-tick-user-close">
                            <p>
                              Closed<span>{us.closed}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Typography>
                </div>
              ))
          )}
        </div>

        <Dialog
          open={isOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want delete that role?"}
          </DialogTitle>

          <DialogActions>
            <Button onClick={deleterole}>SAVE</Button>
            <Button onClick={closeModal}>CANCEL</Button>
          </DialogActions>
        </Dialog>

        <Modal
          isOpen={openDeleteMsg}
          ariaHideApp={false}
          onRequestClose={closeDeleteModal}
          contentLabel="Modal"
          className="modal-popup"
          shouldCloseOnOverlayClick={false}
        >
          <p className="Modal-open-text">Successfully Deleted! </p>
          <div className="delete-art">
            <Button className="delete-art-close" onClick={closeDeleteModal}>
              CLOSE
            </Button>
          </div>
        </Modal>


        <Modal
          isOpen={openAddMsg}
          ariaHideApp={false}
          onRequestClose={closeAddModal}
          contentLabel="Modal"
          className="modal-popup"
          shouldCloseOnOverlayClick={false}
        >
          <p className="Modal-open-text">Successfully added new role! </p>
          <div className="delete-art">
            <Button className="delete-art-close" onClick={closeAddModal}>
              OK
            </Button>
          </div>
        </Modal>
      </div>

     
    </>
  );
};

export default Users;
